<template>
    <div class="flex min-h-screen items-center justify-center p-4 md:p-8 bg-degrade-custom">

        <div class="w-full max-w-5xl rounded-2xl px-6 py-12 md:px-12">

            <header class="text-center">
                <img src="@/assets/img3.png" alt="OverX Logo" class="mx-auto mb-6 h-12 md:h-16">

                <h1 class="text-2xl font-bold text-white sm:text-3xl md:text-4xl">
                    OverX: Transformação Digital na Gestão de Estabelecimentos de Food Service
                </h1>

                <p class="mx-auto mt-4 max-w-3xl text-base text-gray-300">
                    A OverX permite que empresas aumentem suas taxas de conversão e engajamento através da automação e
                    integração inteligente de todos os processos operacionais.
                </p>
            </header>

            <main class="mt-12 flex justify-center">
                <img src="@/assets/Fundo 9.png" alt="Exemplo do componente OverX"
                    class="rounded-lg shadow-2xl shadow-orange-500/10">
            </main>

            <footer class="mt-16 grid grid-cols-1 gap-x-12 gap-y-10 md:grid-cols-2">

                <div class="space-y-3">
                    <h2 class="text-xl font-bold text-black"> A <span class="font-semibold text-orange-600">OverX</span>
                        ajudou a transformar a gestão de estabelecimentos de food service, oferecendo uma plataforma
                        inteligente para integrar os processos de delivery, atendimento à mesa e cozinha.
                    </h2>
                </div>

                <div class="space-y-3">
                    <h2 class="text-xl font-bold text-orange-600">O Desafio</h2>
                    <p class="text-base text-orange-600">
                        Ambas as marcas enfrentavam desafios para engajar sua base de leads e qualificar seus potenciais
                        clientes. A OverX ajudou a superar esses obstáculos com uma plataforma completa e integrada,
                        focada em aumentar a eficiência operacional e a qualificação de leads.
                    </p>
                </div>
            </footer>

        </div>
    </div>
</template>

<script setup>
// Nenhuma lógica necessária para este componente visual estático.
</script>

<style scoped>
.bg-degrade-custom {
    background: linear-gradient(to bottom, black 50%, white 75%);
}
</style>